export const ROCKET_ENDPOINTS = {
  registerPush: "/api/v1/push.token",
  downloadFile: `rocketchat/downloadFile`,
  readSubscriptions: "/api/v1/subscriptions.read",
  usersList: "/api/v1/users.list?",
  userInfo: "/api/v1/me",
};
